<template>
  <div class="pt-course-base">
    <div class="pt-course-base__overlay">
      <div class="pt-course-base__wrapper">
        <NuxtImg
          v-if="course?.main_image?.url"
          :key="course.id"
          :alt="course.main_image.alternativeText || 'course-image'"
          :title="course.meta_title"
          :src="course.main_image?.url || '' || ''"
          loading="lazy"
        />

        <Labels
          v-if="course.recommended"
          label-type="gray"
          :label-text="$t('ui.label.recommended')"
          class="absolute top-0 p-4"
        />
        <Labels
          v-if="course.last_places"
          label-type="red"
          :label-text="$t('ui.label.lastPlaces')"
          class="absolute top-0 p-4"
        />
        <template v-if="getDateLastSession">
          <Labels
            :key="getDateLastSession"
            label-type="white"
            :items="dateToStringWithNameMonth(getDateLastSession)"
            class="absolute bottom-0 p-4"
          />
        </template>
      </div>
    </div>
    <div class="pt-course-base__content">
      <div>
        <nuxt-link :to="`${baseUrl}/${course.slug}`">
          <span v-text="course.meta_title" />
        </nuxt-link>
        <p v-text="course.abstract" />
      </div>
      <Labels
        v-if="course.tags.length"
        label-type="transparent"
        :items="course.tags"
        class="mt-3"
        to-search="events"
      />
    </div>
  </div>
</template>

<script>
import { dateToStringWithNameMonth } from '~/utils/helpers/date';
import Labels from '@/components/Labels';
export default {
  name: 'RelatedCourse',
  components: {
    Labels
  },
  props: {
    course: {
      type: Object,
      default: () => ({})
    },
    baseUrl: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    dateToStringWithNameMonth
  }),
  computed: {
    getDateLastSession() {
      return this.course.list_of_sessions != null
        ? this.course.list_of_sessions[this.course.list_of_sessions.length - 1].date
        : null;
    }
  }
};
</script>

<style scoped src="./style.scss" lang="scss" />
